import TextField, { TextFieldProps } from '@mui/material/TextField';
import { PopupState } from 'material-ui-popup-state/core';
import { styled } from '@mui/material/styles';
import { useWidget } from '@guest-widgets/core';

interface FilterTextField {
  popupState: PopupState;
}

export const FilterTextField = ({
  popupState,
  InputLabelProps,
  InputProps,
  ...props
}: FilterTextField & TextFieldProps) => {
  const { widgetArea } = useWidget();
  const isWideScreen = widgetArea?.isLarge || widgetArea?.isMedium;
  const focusClass = popupState.isOpen ? 'Mui-focused' : undefined;

  return (
    <StyledTextField
      isWideScreen={isWideScreen}
      InputLabelProps={{ shrink: true, className: focusClass, ...InputLabelProps }}
      InputProps={{ readOnly: true, className: focusClass, ...InputProps }}
      variant="outlined"
      size="small"
      color="secondary"
      {...props}
    />
  );
};

const StyledTextField = styled(TextField)<{ isWideScreen: boolean }>(({ isWideScreen }) => ({
  '&.MuiFormControl-root': {
    width: isWideScreen ? 'unset' : '100%',
  },
  '& .RE-MuiInputBase-root, & input': {
    cursor: 'pointer',
  },
  '& .MuiOutlinedInput-input': {
    minWidth: '210px',
  },
}));
